import React from 'react';
import { useParams } from 'react-router-dom';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import BlogGridSimple, { pageCount } from '../component/blog/BlogGridSimple';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import seoData from '../seoData/Blogs.json';
import ErrorPage from './404';

const SITE_URL = 'https://itcodeinfotech.com';

const Blogs = () => {
    const { pageNum } = useParams();

    // A page segment is only present for /blogs/page/:pageNum. Reject
    // anything that isn't a real, in-range page instead of silently
    // falling back to page 1 — an unbounded family of indexable,
    // self-canonicalising duplicate URLs is a real "low value content" risk.
    if (pageNum !== undefined) {
        const requested = parseInt(pageNum, 10);
        const isValid = Number.isInteger(requested)
            && String(requested) === pageNum
            && requested >= 1
            && requested <= pageCount;
        // Page 1 only has a canonical URL at /blogs (no /page/1 segment).
        if (!isValid || requested === 1) {
            return <ErrorPage />;
        }
    }

    const page = parseInt(pageNum, 10);
    const isPaged = Number.isInteger(page) && page >= 2;

    const pagedSeoData = isPaged
        ? {
            ...seoData,
            metaTitle: `${seoData.metaTitle} — Page ${page}`,
            ogTitle: `${seoData.ogTitle} — Page ${page}`,
            metaDescription: `${seoData.metaDescription} (Page ${page})`,
            ogDescription: `${seoData.ogDescription} (Page ${page})`,
            canonicalTag: `${SITE_URL}/blogs/page/${page}`,
            ogUrl: `${SITE_URL}/blogs/page/${page}`,
        }
        : seoData;

    return (
        <>
            <SEO {...pagedSeoData} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne
                    title="Blogs"
                    page="Blog"
                />
                <div className="section-padding-equal">
                    <div className="container">
                        <BlogGridSimple />
                    </div>
                </div>
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default Blogs;
